export const translations = {
  tr: {
    // Header
    nav_timeline: "Zaman Tüneli",
    nav_stats: "İstatistik",
    sidebar_toggle: "Filtreler",
    
    // Intro overlay
    intro_skip: "Geç ✕",
    intro_label: "Gazi Koşusu Tarihi",
    intro_action: "ZAMAN TÜNELİNE GİR",
    intro_quote: '"At yarışları modern toplumlar için sosyal bir ihtiyaçtır."',
    intro_quote_author: "— MUSTAFA KEMAL ATATÜRK",
    btn_show_poll_results: "ANKET SONUÇLARI",
    
    // Stage navigation & tip
    kbd_tip: "Navigasyon için klavyenizin <span>←</span> ve <span>→</span> yön tuşlarını kullanabilirsiniz.",
    
    // Champion Card Labels
    card_label_time: "DERECE",
    card_label_speed: "HIZ (ORTALAMA)",
    card_label_prize: "İKRAMİYE (ALTIN)",
    card_label_jockey: "JOKEY",
    card_label_owner: "SAHİP",
    card_label_summary: "Yarış Özeti",
    card_btn_watch: "Yarışı İzle",
    card_btn_simulate: "ŞAMPİYONLARLA YARIŞTIR",
    card_more_info: "Detaylı Yarış Sonuçları",
    card_press_clipping: "Gazete Kupürü",
    press_modal_title: "Tarihi Gazete Kupürü",
    press_modal_zoom_tip: "💡 İpucu: Resmi tıklayarak veya kaydırarak inceleyebilirsiniz.",
    press_modal_zoom_in: "Büyüt",
    press_modal_zoom_out: "Küçült",
    
    about_modal_title: "Gazi Derby Tarih Arşivi",
    about_modal_purpose_title: "Projenin Amacı",
    about_modal_purpose_text: "Gazi Derby Tarih Arşivi; Türk yarışçılık tarihinin en prestijli kupası olan Gazi Koşusu’nun 1927’den günümüze uzanan görkemli hikayesini interaktif ve modern bir deneyimle yaşatmak amacıyla kurulmuştur.",
    about_modal_legacy_title: "Atatürk'ün Mirası",
    about_modal_legacy_text: "Ulu Önder Mustafa Kemal Atatürk’ün, 'At yarışları modern toplumlar için sosyal bir ihtiyaçtır' sözüyle temellerini attığı Gazi Koşusu, yalnızca bir yarış değil; Türk sporunun en köklü geleneklerinden biridir.",
    about_modal_features_title: "Neler Yapabilirsiniz?",
    about_modal_features_text: "Zaman tünelinde 99 yıllık tarihi keşfedebilir, efsane safkanları simülatörde yarıştırabilir, her yılın koşu ertesi günü yayınlanan gazete kupürlerini inceleyebilir ve Cumhuriyet Altını cinsinden ikramiye değerlerini de içeren detaylı grafikleri analiz edebilirsiniz.",
    about_modal_sources_title: "Veri ve İçerik Kaynakları",
    about_modal_sources_text: "Resmi yarış sonuçları, dereceler ve at/jokey bilgileri Türkiye Jokey Kulübü (TJK) arşivlerinden derlenmiştir. Tarihi hava durumu meteorolojik modellerle simüle edilmiş; basın kupürleri ise Milliyet Gazete Arşivi ve tarihi basın arşivlerinden temin edilmiştir.",
    
    // 2026 Poll details
    poll_badge: "TAHMİN ANKETİ",
    poll_title: "100. GAZİ KOŞUSU",
    poll_label_location: "LOKASYON",
    poll_label_distance: "PİST & MESAFE",
    poll_label_datetime: "TARİH & SAAT",
    poll_label_horses: "SAFKANLAR",
    poll_label_prize: "BİRİNCİLİK ÖDÜLÜ",
    poll_val_location: "İstanbul Veliefendi Hipodromu",
    poll_val_distance: '<span class="val-track">Çim Pist</span><span class="val-separator"> - </span><span class="val-distance">2.400 Metre</span>',
    poll_val_datetime: '<span class="val-date">28 Haziran 2026</span><span class="val-separator"> - </span><span class="val-time">17:15</span>',
    poll_val_horses: "3 Yaşlı 22 İngiliz Safkan",
    poll_val_prize: '50 Milyon TL <span class="prize-bonus">(+50 Milyon TL)</span>',
    poll_btn_join: "ANKET",
    poll_btn_join_long: "ANKETE KATIL",
    poll_btn_analysis: "ANALİZ",
    poll_btn_analysis_long: "ANALİZİ OKU",

    // Analysis Modal
    analysis_badge: "🏆 100. GAZİ KOŞUSU",
    analysis_title: "Rüzgar Bay Nalçakan'dan Yana",
    analysis_subtitle: "28 Haziran 2026 · Uzman Analizi",
    analysis_p1: "28 Haziran'da 100. Gazi Koşusu koşulacak. Son günlerde sosyal medyada ve yarışseverler arasında en çok konuşulan konu netleşti: <strong>Bay Nalçakan</strong> öne geçti.",
    analysis_p2: "6 Haziran'da Ankara'da koşulan Mehmet Akif Ersoy Koşusu'nda Bay Nalçakan, Halis Karataş'la rakibine <strong>7 boy fark</strong> atarak pist rekoru kırdı. O yarışa kadar favori olan Upamecano ise 3. oldu. Bu sonuçtan sonra birçok kişi \"rüzgar döndü\" demeye başladı.",
    analysis_horse1_detail: "Halis Karataş · Pist rekoru kırdı",
    analysis_horse2_detail: "Son yarışta 3. · Hâlâ güçlü aday",
    analysis_horse3_detail: "Sıkça anılan üçüncü isim",
    analysis_horse4_detail: "Sürpriz adayı",
    analysis_tag1: "FAVORİ",
    analysis_tag2: "GÜÇLÜ",
    analysis_tag3: "TAKİPTE",
    analysis_tag4: "SÜRPRİZ",
    analysis_verdict_label: "Tahminimiz",
    analysis_verdict_text: "Bay Nalçakan'ın kazanacağı yönünde. Son formu ve Halis Karataş'ın tecrübesiyle 2400 metreye en hazır görünen at o gibi duruyor. Yine de büyük yarışlarda sürpriz hiç eksik olmuyor.",
    
    // Stats Stage Headers
    stats_header_title: "Gazi Koşusu İstatistik Analizi",
    stats_header_subtitle: "1927'den günümüze tüm koşuların hız trendleri ve başarı sıralamaları",
    
    // Stats Cards
    stats_card_record_label: "Kırılmaz Derece Rekoru",
    stats_card_jockey_label: "En Başarılı Jokey",
    stats_card_owner_label: "En Başarılı Eküri",
    stats_card_years_label: "Filtrelenmiş Koşu Yılı",
    stats_card_record_value: "2.26.22",
    stats_card_record_desc: "Bold Pilot (1996)",
    stats_card_jockey_value: "9 Zafer",
    stats_card_jockey_desc: "Mümin Çılgın",
    stats_card_owner_value: "13 Zafer",
    stats_card_owner_desc: "Eliyeşil Ekürisi",
    stats_card_years_desc: "1927 - 2026 Tarih Arşivi",
    
    // Charts
    chart_title_time: "Derece Analizi",
    chart_subtitle_time: "Yıllara Göre Kazanan Safkanların Derece Trendleri",
    chart_title_speed: "Hız Analizi",
    chart_subtitle_speed: "Yıllara Göre Kazanan Safkanların Ortalama Hız Trendleri",
    chart_title_prize: "Satın Alma Gücü Analizi",
    chart_subtitle_prize: "Gazi Koşusu Birincilik Ödülünün Cumhuriyet Altını Cinsinden Değeri",
    chart_btn_time: "Derece (Süre)",
    chart_btn_speed: "Ortalama Hız (km/s)",
    chart_btn_prize: "İkramiye (Altın Karşılığı)",
    chart_scroll_tip: "Grafiği sağa/sola kaydırabilirsiniz",
    chart_footnote: "1927–1931 yılları arasındaki koşular 2000 metre, sonraki koşular ise 2400 metre mesafede düzenlenmiştir.",
    chart_jockeys_title: "En Çok Kazanan Jokeyler (Top 8)",
    chart_owners_title: "En Çok Kazanan Sahipler / Eküriler (Top 8)",
    
    // Trivia Toggle
    btn_trivia_toggle: "Diğer İstatistikler & Tarihi Bilgiler",
    
    // Trivia Section
    trivia_title: "Gazi Efsaneleri, Tarihi Rekorlar & İlginç Bilgiler",
    trivia_subtitle: "Derbi tarihinin dilden dele dolaşan efsanevi soy hatları, rekorlar ve nadir durumlar",
    
    // Trivia Card 1
    trivia_c1_title: "Kendisi & Yavrusu Gazi Kazananlar",
    trivia_c1_i1: "<strong>Cap Gris Nez:</strong> Yavruları Yılmazkaya ve efsanevi Karayel de Gazi şampiyonudur.",
    trivia_c1_i2: "<strong>I. Seren:</strong> Yavrusu Cartagena da Gazi Koşusu'nu kazanmıştır.",
    trivia_c1_i3: "<strong>Akkor:</strong> Yavrusu Toraman ile birlikte derbi tarihine geçmişlerdir.",
    trivia_c1_i4: "<strong>George Thomas:</strong> Yavrusu Caprice ile aynı kupayı kazanma gururunu yaşamıştır.",
    trivia_c1_i5: "<strong>Darling:</strong> Kendisi (1950) ve yavrusu Atlıhan (1961) Gazi şampiyonudur.",
    
    // Trivia Card 2
    trivia_c2_title: "En Başarılı Aygır & Kısraklar",
    trivia_c2_h1: "En Çok Gazi Kazanan Yavru Veren Aygırlar:",
    trivia_c2_h2: "En Çok Gazi Kazanan Yavru Veren Kısrak:",
    trivia_c2_sires: [
      "Cihangir: 6 kez yavrusu Gazi kazandı.",
      "Coup De Roi: 5 kez yavrusu Gazi kazandı.",
      "Wings Of Song: 5 kez yavrusu Gazi kazandı.",
      "Onyx II: 5 kez yavrusu Gazi kazandı."
    ],
    trivia_c2_dams: [
      "Fleche d'Or: 3 kez (Beau Brummel, La Fleche, Beau Monair yavruları kazandı)."
    ],
    
    // Trivia Card 3
    trivia_c3_title: "Eküri Biten Gazi Koşuları",
    trivia_c3_desc: "Gazi Koşusu tarihinde, aynı ekürinin taylarının ilk iki sırayı paylaştığı (veya birlikte bitirdiği) nadir eküri birincilikleri:",
    trivia_c3_i1: "1956: La Fleche – Cantatrice birinciliği paylaştı.",
    trivia_c3_i2: "1986: Hafız – Kapkara ikilisiyle Eliyeşil ekürisi kazandı.",
    trivia_c3_i3: "1993: The Best – I. Thunder Bold ikilisiyle Kurt ekürisi kazandı.",
    
    // Trivia Card 4
    trivia_c4_title: "Tarihi Bireysel Rekorlar",
    trivia_c4_i1: "<strong>Bold Pilot (1996):</strong> 2.26.22'lik bitiriş derecesiyle 30 yıldır kırılamayan rekorun sahibidir.",
    trivia_c4_i2: "<strong>Mümin Çılgın:</strong> 9 zaferle Gazi Koşusu'nu en çok kazanan jokey unvanını elinde tutmaktadır.",
    trivia_c4_i3: "<strong>Ahmet Çelik:</strong> 2015–2021 yılları arasında üst üste 7 yıl kazanarak inanılmaz bir seriye imza atmıştır.",
    trivia_c4_i4: "<strong>Eliyeşil Ekürisi:</strong> Toplam 13 zafer ile Gazi Koşusu tarihinin en başarılı ekürisidir.",
    
    // Sidebar Filters
    sb_search_title: "Şampiyon Ara",
    sb_search_placeholder: "At, jokey, sahip veya yıl...",
    sb_filter_era: "Dönem Filtresi",
    sb_filter_all: "Tümü",
    sb_filter_legends: "Sadece Efsaneleri Göster",
    sb_filter_city: "Şehir Filtresi",
    sb_city_istanbul: "İstanbul",
    sb_city_ankara: "Ankara",
    
    // Sidebar Stats Glance
    sb_glance_title: "Kısaca İstatistikler",
    sb_glance_races: "Düzenlenen Koşu:",
    sb_glance_record: "Hız Rekoru:",
    sb_glance_jockey: "En Çok Galip Jokey:",
    sb_glance_streak: "Kırılmaz Jokey Serisi:",
    sb_glance_owner: "En Çok Kazanan Eküri:",
    sb_glance_first: "İlk Şampiyon:",
    sb_glance_limit: "Katılım Sınırı:",
    sb_glance_limit_val: "Ömürde Sadece 1 Kez",
    
    // Sidebar Quiz Promo
    sb_quiz_badge: "MİNİ OYUN",
    sb_quiz_title: "Gazi Derbisi Bilgi Yarışması",
    sb_quiz_desc: "Tarih, rekorlar ve efsane safkanlar hakkındaki bilgini test et!",
    sb_quiz_btn: "Yarışmayı Başlat",
    
    // Mobile Bottom Nav
    mob_nav_timeline: "Zaman Tüneli",
    mob_nav_stats: "İstatistik",
    
    // Countdown
    cd_title: "Gazi Koşusu'na Kalan Süre",
    cd_days: "Gün",
    cd_hours: "Saat",
    cd_mins: "Dk",
    cd_secs: "Sn",
    
    // Simulator Modal Header
    sim_badge: "EFSANELER ARENASI",
    sim_title: "Bold Pilot'a Karşı Yarış",
    sim_desc: "Süre rekoru sahibi Bold Pilot ile diğer şampiyonların bitiriş derecelerini ve koşu stillerini kıyaslayın.",
    
    // Simulator Competitors
    sim_lane1_label: "1. KULVAR (SABİT)",
    sim_lane1_meta: "Derece: 2.26.22 (Rekor)",
    sim_lane2_label: "2. KULVAR (RAKİP)",
    sim_vs: "VS",
    sim_label_speed: "Hız:",
    sim_label_distance: "Mesafe:",
    
    // Simulator Live Commentary
    sim_comm_header: "🎤 YARIŞ SPİKERİ",
    sim_comm_init: 'Yarışı başlatmak için "Yarışı Başlat" butonuna tıklayın.',
    
    // Simulator Buttons
    sim_btn_start: "YARIŞI BAŞLAT",
    sim_btn_pause: "YARIŞI DURAKLAT",
    sim_btn_resume: "YARIŞA DEVAM ET",
    sim_btn_restart: "YENİDEN BAŞLAT",
    sim_btn_completed: "YARIŞ TAMAMLANDI",
    
    // Quiz Screen 1
    quiz_title: "Gazi Koşusu Bilgi Yarışması",
    quiz_intro: "Gazi Koşusu tarihi, şampiyonlar, efsane jokeyler ve kırılmayan rekorlar hakkında 5 soruluk test. Kendini dene, ünvanını kazan!",
    quiz_btn_start: "YARIŞMAYA BAŞLA",
    
    // Quiz Screen 2
    quiz_question_meta: "Soru",
    
    // Quiz Screen 3
    quiz_score_label: "Skorun:",
    quiz_btn_retry: "YENİDEN DENE",
    quiz_btn_share: "SONUCU PAYLAŞ",
    
    // Dynamic Stats Text Formatters
    stats_races_unit: "Koşu",
    stats_total_years_desc: "Tarih Arşivi",
    stats_years_unit: "Yıl",
    
    // General
    close: "Kapat",
    video_closed: "✕ Kapat",
    swipe_hint: "Geçiş İçin Kaydırın",
    trivia_img_desc: "İstanbul Kağıthane’de at yarışı, 1909.",
    podium_second_title: "İkinciyi Göster",
    podium_third_title: "Üçüncüyü Göster",
    podium_second_place: "İkinci: ",
    podium_third_place: "Üçüncü: "
  },
  en: {
    // Header
    nav_timeline: "Timeline",
    nav_stats: "Statistics",
    sidebar_toggle: "Filters",
    
    // Intro overlay
    intro_skip: "Skip ✕",
    intro_label: "Gazİ Derby History",
    intro_action: "ENTER TIMELINE",
    intro_quote: '"Horse racing is a social need for modern societies."',
    intro_quote_author: "— MUSTAFA KEMAL ATATURK",
    btn_show_poll_results: "POLL RESULTS",
    
    // Stage navigation & tip
    kbd_tip: "You can use your keyboard's <span>←</span> and <span>→</span> arrow keys for navigation.",
    
    // Champion Card Labels
    card_label_time: "TIME",
    card_label_speed: "AVG SPEED",
    card_label_prize: "PRIZE (GOLD)",
    card_label_jockey: "JOCKEY",
    card_label_owner: "OWNER",
    card_label_summary: "Race Summary",
    card_btn_watch: "Watch Race",
    card_btn_simulate: "RACE WITH CHAMPIONS",
    card_more_info: "Detailed Race Results",
    card_press_clipping: "Newspaper Clipping",
    press_modal_title: "Historical Newspaper Clipping",
    press_modal_zoom_tip: "💡 Tip: Click or scroll to inspect the image.",
    press_modal_zoom_in: "Zoom In",
    press_modal_zoom_out: "Zoom Out",
    
    about_modal_title: "Gazi Derby Historical Archive",
    about_modal_purpose_title: "Project Purpose",
    about_modal_purpose_text: "Gazi Derby Historical Archive is established to keep the grand story of the Gazi Derby, the most prestigious cup in Turkish racing history since 1927, alive through a modern and interactive experience.",
    about_modal_legacy_title: "Atatürk's Legacy",
    about_modal_legacy_text: "Founded upon the Great Leader Mustafa Kemal Atatürk's quote, 'Horse racing is a social necessity for modern societies', the Gazi Derby is not just a race, but one of the most deep-rooted traditions of Turkish sports.",
    about_modal_features_title: "What Can You Do?",
    about_modal_features_text: "Explore a 99-year history in the timeline, race legendary horses in the simulator, inspect newspaper clippings from the day after each race, and analyze detailed charts including historical prize values in terms of gold coins.",
    about_modal_sources_title: "Data & Media Sources",
    about_modal_sources_text: "Official race results, timings, and horse/jockey details are compiled from the TJK archives. Historical weather is simulated via meteorological models, and press clippings are obtained from the Milliyet Newspaper Archive and historical press collections.",
    
    // 2026 Poll details
    poll_badge: "PREDICTION POLL",
    poll_title: "100th GAZİ DERBY",
    poll_label_location: "LOCATION",
    poll_label_distance: "TRACK & DISTANCE",
    poll_label_datetime: "DATE & TIME",
    poll_label_horses: "HORSES",
    poll_label_prize: "FIRST PRIZE",
    poll_val_location: "Istanbul Veliefendi Racetrack",
    poll_val_distance: '<span class="val-track">Turf Track</span><span class="val-separator"> - </span><span class="val-distance">2,400 Meters</span>',
    poll_val_datetime: '<span class="val-date">June 28, 2026</span><span class="val-separator"> - </span><span class="val-time">17:15</span>',
    poll_val_horses: "22 3-Year-Old Thoroughbreds",
    poll_val_prize: '50 Million TL <span class="prize-bonus">(+50 Million TL)</span>',
    poll_btn_join: "POLL",
    poll_btn_join_long: "JOIN THE POLL",
    poll_btn_analysis: "ANALYSIS",
    poll_btn_analysis_long: "READ ANALYSIS",

    // Analysis Modal
    analysis_badge: "🏆 100th GAZI DERBY",
    analysis_title: "The Wind Blows in Bay Nalçakan's Favour",
    analysis_subtitle: "June 28, 2026 · Expert Analysis",
    analysis_p1: "The 100th Gazi Derby will be run on June 28th. The most talked-about topic in social media and racing circles has become clear: <strong>Bay Nalçakan</strong> is ahead.",
    analysis_p2: "In the Mehmet Akif Ersoy Stakes run in Ankara on June 6th, Bay Nalçakan, ridden by Halis Karataş, beat his rival by <strong>7 lengths</strong>, setting a track record. Upamecano, who had been the favourite up until that race, finished 3rd. After this result, many began to say \"the wind has turned.\"",
    analysis_horse1_detail: "Halis Karataş · Track record set",
    analysis_horse2_detail: "3rd in last race · Still a strong contender",
    analysis_horse3_detail: "Frequently mentioned third candidate",
    analysis_horse4_detail: "Dark horse candidate",
    analysis_tag1: "FAVOURITE",
    analysis_tag2: "STRONG",
    analysis_tag3: "WATCH",
    analysis_tag4: "DARK HORSE",
    analysis_verdict_label: "Our Prediction",
    analysis_verdict_text: "We tip Bay Nalçakan to win. With his recent form and Halis Karataş's experience, he looks the most prepared horse for the 2,400 metres. That said, surprises are never in short supply in big races like this.",
    
    // Stats Stage Headers
    stats_header_title: "Gazi Derby Statistical Analysis",
    stats_header_subtitle: "Speed trends and success rankings of all races from 1927 to present",
    
    // Stats Cards
    stats_card_record_label: "Unbroken Time Record",
    stats_card_jockey_label: "Most Successful Jockey",
    stats_card_owner_label: "Most Successful Stable",
    stats_card_years_label: "Filtered Race Years",
    stats_card_record_value: "2.26.22",
    stats_card_record_desc: "Bold Pilot (1996)",
    stats_card_jockey_value: "9 Victories",
    stats_card_jockey_desc: "Mumin Cilgin",
    stats_card_owner_value: "13 Victories",
    stats_card_owner_desc: "Eliyesil Stable",
    stats_card_years_desc: "1927 - 2026 Historical Archive",
    
    // Charts
    chart_title_time: "Finish Time Analysis",
    chart_subtitle_time: "Finish Time Trends of Winning Thoroughbreds by Year",
    chart_title_speed: "Speed Analysis",
    chart_subtitle_speed: "Average Speed Trends of Winning Thoroughbreds by Year",
    chart_title_prize: "Purchasing Power Analysis",
    chart_subtitle_prize: "Gazi Derby First Prize Value in Terms of Republican Gold Coins",
    chart_btn_time: "Time",
    chart_btn_speed: "Average Speed (km/h)",
    chart_btn_prize: "Prize (Gold Equivalent)",
    chart_scroll_tip: "You can scroll the chart left/right",
    chart_footnote: "Races between 1927 and 1931 were held at 2000 meters; subsequent races have been at 2400 meters.",
    chart_jockeys_title: "Most Winning Jockeys (Top 8)",
    chart_owners_title: "Most Winning Owners / Stables (Top 8)",
    
    // Trivia Toggle
    btn_trivia_toggle: "Other Statistics & Historical Info",
    
    // Trivia Section
    trivia_title: "Gazi Legends, Historical Records & Interesting Facts",
    trivia_subtitle: "Legendary pedigree lines, records, and rare occurrences in the Derby's history",
    
    // Trivia Card 1
    trivia_c1_title: "Sire/Dam & Foal Gazi Winners",
    trivia_c1_i1: "<strong>Cap Gris Nez:</strong> Offspring Yilmazkaya and legendary Karayel are also Gazi champions.",
    trivia_c1_i2: "<strong>I. Seren:</strong> Offspring Cartagena also won the Gazi Derby.",
    trivia_c1_i3: "<strong>Akkor:</strong> Entered derby history together with offspring Toraman.",
    trivia_c1_i4: "<strong>George Thomas:</strong> Shared the pride of winning the same trophy with offspring Caprice.",
    trivia_c1_i5: "<strong>Darling:</strong> Herself (1950) and offspring Atlihan (1961) are both Gazi champions.",
    
    // Trivia Card 2
    trivia_c2_title: "Most Successful Sires & Dams",
    trivia_c2_h1: "Sires with Most Gazi Winning Offspring:",
    trivia_c2_h2: "Dam with Most Gazi Winning Offspring:",
    trivia_c2_sires: [
      "Cihangir: 6 offspring won the Gazi.",
      "Coup De Roi: 5 offspring won the Gazi.",
      "Wings Of Song: 5 offspring won the Gazi.",
      "Onyx II: 5 offspring won the Gazi."
    ],
    trivia_c2_dams: [
      "Fleche d'Or: 3 offspring won (Beau Brummel, La Fleche, Beau Monair)."
    ],
    
    // Trivia Card 3
    trivia_c3_title: "Gazi Derby Quinella Finishes",
    trivia_c3_desc: "Rare instances in Gazi Derby history where horses from the same stable shared or finished in the top two positions:",
    trivia_c3_i1: "1956: La Fleche – Cantatrice shared the first place.",
    trivia_c3_i2: "1986: Eliyesil stable won with the duo Hafiz – Kapkara.",
    trivia_c3_i3: "1993: Kurt stable won with the duo The Best – I. Thunder Bold.",
    
    // Trivia Card 4
    trivia_c4_title: "Historical Individual Records",
    trivia_c4_i1: "<strong>Bold Pilot (1996):</strong> Holds the record for 30 years with a finish time of 2.26.22.",
    trivia_c4_i2: "<strong>Mumin Cilgin:</strong> Holds the title of the most winning jockey in the Gazi Derby with 9 victories.",
    trivia_c4_i3: "<strong>Ahmet Celik:</strong> Achieved an incredible streak of winning 7 consecutive years between 2015 and 2021.",
    trivia_c4_i4: "<strong>Eliyesil Stable:</strong> The most successful stable in Gazi Derby history with a total of 13 victories.",
    
    // Sidebar Filters
    sb_search_title: "Search Champion",
    sb_search_placeholder: "Horse, jockey, owner, or year...",
    sb_filter_era: "Era Filter",
    sb_filter_all: "All",
    sb_filter_legends: "Show Legends Only",
    sb_filter_city: "City Filter",
    sb_city_istanbul: "Istanbul",
    sb_city_ankara: "Ankara",
    
    // Sidebar Stats Glance
    sb_glance_title: "Stats at a Glance",
    sb_glance_races: "Races Held:",
    sb_glance_record: "Speed Record:",
    sb_glance_jockey: "Most Winning Jockey:",
    sb_glance_streak: "Unbroken Jockey Streak:",
    sb_glance_owner: "Most Winning Stable:",
    sb_glance_first: "First Champion:",
    sb_glance_limit: "Participation Limit:",
    sb_glance_limit_val: "Only Once in a Lifetime",
    
    // Sidebar Quiz Promo
    sb_quiz_badge: "MINI GAME",
    sb_quiz_title: "Gazİ Derby Quiz",
    sb_quiz_desc: "Test your knowledge on history, records, and legendary thoroughbreds!",
    sb_quiz_btn: "Start Quiz",
    
    // Mobile Bottom Nav
    mob_nav_timeline: "Timeline",
    mob_nav_stats: "Statistics",
    
    // Countdown
    cd_title: "Time Remaining to Gazİ Derby",
    cd_days: "Days",
    cd_hours: "Hours",
    cd_mins: "Mins",
    cd_secs: "Secs",
    
    // Simulator Modal Header
    sim_badge: "ARENA OF LEGENDS",
    sim_title: "Race Against Bold Pilot",
    sim_desc: "Compare the finish times and running styles of record-holder Bold Pilot with other champions.",
    
    // Simulator Competitors
    sim_lane1_label: "LANE 1 (FIXED)",
    sim_lane1_meta: "Time: 2.26.22 (Record)",
    sim_lane2_label: "LANE 2 (OPPONENT)",
    sim_vs: "VS",
    sim_label_speed: "Speed:",
    sim_label_distance: "Distance:",
    
    // Simulator Live Commentary
    sim_comm_header: "🎤 RACE COMMENTARY",
    sim_comm_init: 'Click "Start Race" to begin the race.',
    
    // Simulator Buttons
    sim_btn_start: "START RACE",
    sim_btn_pause: "PAUSE RACE",
    sim_btn_resume: "RESUME RACE",
    sim_btn_restart: "RESTART",
    sim_btn_completed: "RACE COMPLETED",
    
    // Quiz Screen 1
    quiz_title: "Gazi Derby Quiz",
    quiz_intro: "A 5-question test on the history, champions, legendary jockeys, and unbroken records of the Gazi Derby. Test yourself, claim your title!",
    quiz_btn_start: "START QUIZ",
    
    // Quiz Screen 2
    quiz_question_meta: "Question",
    
    // Quiz Screen 3
    quiz_score_label: "Your Score:",
    quiz_btn_retry: "TRY AGAIN",
    quiz_btn_share: "SHARE RESULT",
    
    // Dynamic Stats Text Formatters
    stats_races_unit: "Races",
    stats_total_years_desc: "Historical Archive",
    stats_years_unit: "Years",
    
    // General
    close: "Close",
    video_closed: "✕ Close",
    swipe_hint: "Swipe to Switch",
    trivia_img_desc: "Horse racing in Istanbul Kağıthane, 1909.",
    podium_second_title: "Show Second Place",
    podium_third_title: "Show Third Place",
    podium_second_place: "Second: ",
    podium_third_place: "Third: "
  }
};

export const QUIZ_QUESTIONS_TR = [
  {
    question: "Bold Pilot'ın 1996 yılından beri kırılamayan Gazi Koşusu rekor derecesi hangisidir?",
    options: ["2.26.22", "2.27.36", "2.28.03", "2.30.15"],
    answer: "2.26.22"
  },
  {
    question: "Gazi Koşusu'nu 9 galibiyetle en çok kazanan efsane jokey kimdir?",
    options: ["Mümin Çılgın", "Halis Karataş", "Ekrem Kurt", "Ahmet Çelik"],
    answer: "Mümin Çılgın"
  },
  {
    question: "2015-2021 yılları arasında üst üste 7 kez Gazi Koşusu kazanarak rekor kıran jokey kimdir?",
    options: ["Ahmet Çelik", "Halis Karataş", "Süleyman Akdı", "Mümin Çılgın"],
    answer: "Ahmet Çelik"
  },
  {
    question: "1927 yılında düzenlenen ilk Gazi Koşusu'nu kazanan safkan hangisidir?",
    options: ["Neriman", "Olgo", "Çobankızı", "La Fleche"],
    answer: "Neriman"
  },
  {
    question: "1927'de ilk Gazi Koşusu'nu kazanan Neriman'ın sahibi kimdir?",
    options: ["Ali Muhittin Hacı Bekir", "Celal Bayar", "İsmet İnönü", "Özdemir Atman"],
    answer: "Ali Muhittin Hacı Bekir"
  },
  {
    question: "Cumhurbaşkanı İsmet İnönü'nün 1930 yılında Gazi Koşusu kazanan atının adı nedir?",
    options: ["Olgo", "Neriman", "Lale", "Sabutay"],
    answer: "Olgo"
  },
  {
    question: "Cumhurbaşkanı Celal Bayar'ın 1929 yılında Gazi Koşusu kazanan atının adı nedir?",
    options: ["Cap Gris Nez", "Primerole", "Romance", "Ece"],
    answer: "Cap Gris Nez"
  },
  {
    question: "Gazi Koşusu tarihinde 13 galibiyetle en başarılı eküri hangisidir?",
    options: ["Eliyeşil Ekürisi", "Atman Ekürisi", "Kurtel Ekürisi", "Karamehmet Ekürisi"],
    answer: "Eliyeşil Ekürisi"
  },
  {
    question: "Bir İngiliz tayı hayatı boyunca Gazi Koşusu'na en fazla kaç kez katılabilir?",
    options: ["1", "2", "3", "Sınırsız"],
    answer: "1"
  },
  {
    question: "Efsane safkan Bold Pilot ile Gazi Koşusu rekorunu kıran jokey kimdir?",
    options: ["Halis Karataş", "Ahmet Çelik", "Ekrem Kurt", "Süleyman Akdı"],
    answer: "Halis Karataş"
  }
];

export const QUIZ_QUESTIONS_EN = [
  {
    question: "What is Bold Pilot's record time in the Gazi Derby, which has remained unbroken since 1996?",
    options: ["2.26.22", "2.27.36", "2.28.03", "2.30.15"],
    answer: "2.26.22"
  },
  {
    question: "Who is the legendary jockey with the most Gazi Derby victories (9 wins)?",
    options: ["Mumin Cilgin", "Halis Karatas", "Ekrem Kurt", "Ahmet Celik"],
    answer: "Mumin Cilgin"
  },
  {
    question: "Which jockey set a record by winning the Gazi Derby 7 times consecutively between 2015 and 2021?",
    options: ["Ahmet Celik", "Halis Karatas", "Suleyman Akdi", "Mumin Cilgin"],
    answer: "Ahmet Celik"
  },
  {
    question: "Which thoroughbred won the first ever Gazi Derby held in 1927?",
    options: ["Neriman", "Olgo", "Cobankizi", "La Fleche"],
    answer: "Neriman"
  },
  {
    question: "Who was the owner of Neriman, the winner of the first Gazi Derby in 1927?",
    options: ["Ali Muhittin Haci Bekir", "Celal Bayar", "Ismet Inonu", "Ozdemir Atman"],
    answer: "Ali Muhittin Haci Bekir"
  },
  {
    question: "What was the name of President Ismet Inonu's horse that won the Gazi Derby in 1930?",
    options: ["Olgo", "Neriman", "Lale", "Sabutay"],
    answer: "Olgo"
  },
  {
    question: "What was the name of President Celal Bayar's horse that won the Gazi Derby in 1929?",
    options: ["Cap Gris Nez", "Primerole", "Romance", "Ece"],
    answer: "Cap Gris Nez"
  },
  {
    question: "Which is the most successful stable in Gazi Derby history with 13 victories?",
    options: ["Eliyesil Stable", "Atman Stable", "Kurtel Stable", "Karamehmet Stable"],
    answer: "Eliyesil Stable"
  },
  {
    question: "What is the maximum number of times an English thoroughbred can participate in the Gazi Derby?",
    options: ["1", "2", "3", "Unlimited"],
    answer: "1"
  },
  {
    question: "Who is the jockey who set the Gazi Derby record riding the legendary thoroughbred Bold Pilot?",
    options: ["Halis Karatas", "Ahmet Celik", "Ekrem Kurt", "Suleyman Akdi"],
    answer: "Halis Karatas"
  }
];

export const SIMULATOR_COMMENTARY_TR = {
  step1: "Start kutuları açıldı ve derbi başladı! Kulvarlarından çıkan safkanlar liderlik mücadelesine girişiyor.",
  step2: "Koşunun ilk metreleri... [OPPONENT] tempoyu belirliyor. Bold Pilot ise her zamanki gibi sakin, en geride yerini aldı.",
  step3: "Karşı düzlüğe çıkıldı! Safkanlar tempoyu koruyor. Bold Pilot, [OPPONENT]'in yaklaşık 8-10 boy gerisinde sabırla takip ediyor.",
  step4: "Son 1000 metre geçildi! Viraj yavaş yavaş dönülüyor. Jokey Halis Karataş henüz Bold Pilot'ı kamçılamadı, beklemede.",
  step5: "Son düzlük dönüldü! Son 400 metreye girilmek üzere! [OPPONENT] liderliğini koruyor, Bold Pilot dış kulvara açılıyor!",
  step6: "Son 300 metre! BOLD PILOT dış kulvardan inanılmaz bir sprintle atağa kalktı! Sürati saatte 65 kilometreyi geçiyor! Tribünler ayakta!",
  step7: "Son 100 metre! Müthiş bir kafa kafaya mücadele! Bold Pilot uçarcasına geliyor, [OPPONENT] direnmeye çalışıyor!",
  winner_bold_pilot: "Ve yarışı BOLD PILOT kazanıyor! 2.26.22'lik derecesiyle efsane rekorunu koruyor ve Halis Karataş ile zafere uzanıyor!",
  winner_opponent: "Ve yarışı [OPPONENT] kazanıyor! İnanılmaz bir dereceyle Bold Pilot'ın önünde bitirmeyi başarıyor!"
};

export const SIMULATOR_COMMENTARY_EN = {
  step1: "The starting gates open and the derby begins! Thoroughbreds break out of their lanes, battling for the early lead.",
  step2: "First meters of the race... [OPPONENT] sets the pace. Bold Pilot is calm as usual, settling at the very back of the field.",
  step3: "Entering the backstretch! Thoroughbreds maintain their pace. Bold Pilot trails [OPPONENT] patiently by about 8 to 10 lengths.",
  step4: "Passed the final 1000 meters! Turning the corner slowly. Jockey Halis Karatas has not whipped Bold Pilot yet, biding his time.",
  step5: "Entering the final stretch! Passing the 400-meter mark! [OPPONENT] holds the lead, Bold Pilot makes his move to the outside lane!",
  step6: "Final 300 meters! BOLD PILOT launches an incredible sprint from the outside! Speed exceeds 65 km/h! The grandstand is on its feet!",
  step7: "Final 100 meters! A thrilling head-to-head battle! Bold Pilot is flying, [OPPONENT] is trying hard to resist!",
  winner_bold_pilot: "And BOLD PILOT wins the race! He defends his legendary record with a time of 2.26.22, stretching to victory with Halis Karatas!",
  winner_opponent: "And [OPPONENT] wins the race! Finishing ahead of Bold Pilot with an unbelievable performance!"
};

export const LEGEND_TITLES_EN = {
  "KIRILMAZ REKOR": "UNBROKEN RECORD",
  "ÜÇLÜ TAÇ ŞAMPİYONU": "TRIPLE CROWN CHAMPION",
  "PİSTLERİN EFENDİSİ": "LORD OF THE TRACKS",
  "ÜÇLÜ TAÇ SAHİBİ": "TRIPLE CROWN WINNER",
  "GEÇİLMEZ EFSANE": "UNDEFEATED LEGEND",
  "EFSANE KISRAK": "LEGENDARY FILLY",
  "İLK ÜÇLÜ TAÇ": "FIRST TRIPLE CROWN",
  "İLK ŞAMPİYON": "FIRST CHAMPION",
  "MİLYONLARIN SEVGİLİSİ": "BELOVED BY MILLIONS",
  "TAHMİN ANKETİ": "PREDICTION POLL"
};

export const MONTHS_TR_TO_EN = {
  "Haziran": "June",
  "Temmuz": "July",
  "Ağustos": "August",
  "Eylül": "September",
  "Ekim": "October",
  "Kasım": "November",
  "Aralık": "December",
  "Ocak": "January",
  "Şubat": "February",
  "Mart": "March",
  "Nisan": "April",
  "Mayıs": "May"
};
